<section
  class="section-bottom-hero"
  *ngIf="heroData && !heroData?.psCustomerStoryPdf"
>
  <div class="section-bottom-container">
    <div class="product-bottom-content-box justfy-item-e">
      <div class="product-bottom-content">
        <span class="product-hero-subheading mar-b-16">{{
          heroData?.badge
        }}</span>
        <h1 class="product-hero-header">{{ heroData?.header }}</h1>
        <div
          class="landing-hero-content mar-t-24"
          [innerHtml]="heroData?.paragraph | toHtml"
        ></div>
      </div>
      <img src="{{ heroData.image.url }}" alt="{{ heroData.image.alt }}" />
    </div>
  </div>
</section>

<section
  class="section-bottom-hero"
  *ngIf="heroData && heroData?.psCustomerStoryPdf"
>
  <div class="section-bottom-container">
    <div class="product-bottom-content-box justfy-item-e">
      <div class="product-bottom-content">
        <h1 class="product-hero-header">
          {{ heroData?.header }}
        </h1>
        <div class="landing-btn mar-t-48 align-c">
          <button
            class="btn btn-full"
            (click)="scrollTo()"
            *ngFor="let button of heroData?.buttons"
          >
            {{ button.buttonText }}
          </button>
        </div>
      </div>
      <img src="{{ heroData.image.url }}" alt="{{ heroData.image.alt }}" />
    </div>
  </div>
</section>
